import { useLocation } from "react-router-dom"

function usePathname() {
  const pathname = useLocation().pathname
  return pathname
}

export default usePathname
